import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingPersonAttributeType,
    getPersonAttributeTypeById,
    saveOrUpdatePersonAttributeType,
    deletePersonAttributeType
} from 'app/services/PersonAttributeTypeService';

import { PersonAttributeType } from "app/common/Model/PersonAttributeType";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class PersonAttributeTypeStore {
    listAllPersonAtrributeType = [];
    searchPersonAttributeType = new SearchObject();
    pagePersonAttributeType = null;
    selectedPersonAttributeType = null;
    openFormCreateOrEdit = false;
    openConfirmDeletePersonAttributeType = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingPersonAttributeType = () => {
        pagingPersonAttributeType(this.searchPersonAttributeType).then(({ data }) => {
            this.pagePersonAttributeType = data;
        })
    }

    handleChangeFormSearch = (searchPersonAttributeType) => {
        this.searchPersonAttributeType = checkSearchObject(this.searchPersonAttributeType, searchPersonAttributeType);
        this.pagingPersonAttributeType();
    }

    handleOpenFormCreateOrEdit = (personAttributeTypeId) => {
        if (Boolean(personAttributeTypeId)) {
            getPersonAttributeTypeById(personAttributeTypeId).then(({ data }) => {
                this.selectedPersonAttributeType = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                console.error(error);
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedPersonAttributeType = new PersonAttributeType();
            this.openFormCreateOrEdit = true;
        }
    }

    saveHealthCareService = (personAttributeType, { setSubmitting }) => {
        saveOrUpdatePersonAttributeType(personAttributeType).then(() => {
            this.selectedPersonAttributeType = null;
            toast.success("Lưu loại thuộc tính người thành công!");
            this.pagingPersonAttributeType();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Lưu loại thuộc tính người thất bại!");
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeletePersonAttributeType = (personAttributeTypeId) => {
        this.selectedPersonAttributeType = { id: personAttributeTypeId?.id };
        this.openConfirmDeletePersonAttributeType = true;
    }

    handleConfirmDeletePersonAttributeType = () => deletePersonAttributeType(this.selectedPersonAttributeType?.id)
        .then(() => {
            if (this.searchPersonAttributeType?.pageIndex > 1 && this.pagePersonAttributeType?.content.length === 1) {
                this.searchPersonAttributeType.pageIndex -= 1;
            }
            toast.success("Xóa loại thuộc tính người thành công!");
            this.pagingPersonAttributeType();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa loại thuộc tính người thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeletePersonAttributeType = false;
    }

    resetStore = () => {
        this.searchPersonAttributeType = new SearchObject();
        this.pagePersonAttributeType = null;
        this.selectedPersonAttributeType = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeletePersonAttributeType = false;
    }
}